import { ReferralService } from './../../services/referral.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Person, bankDetails, referralUser } from 'src/app/models/myreferrals.model';
import { map } from 'rxjs/internal/operators/map';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { AddressDialogComponent } from 'src/app/my-customers/address-dialog/address-dialog.component';
import { AddressService } from 'src/app/services/address.service';
import { ToastrService } from 'ngx-toastr';
import { MyReferral } from 'src/app/models/myreferrals.model copy';

@Component({
  selector: 'app-referralregister',
  templateUrl: './referralregister.component.html',
  styleUrls: ['./referralregister.component.css']
})
export class ReferralregisterComponent implements OnInit {
  selected = '';
  referralForm: FormGroup;
  hasFormErrors: boolean = false;
  countryList = [];
  stateList = [];
  cityList = [];
  filterArrayCountry = [];
  filterArrayState = [];
  filterArrayCity = [];
  localityList = [];
  temp: boolean = false
  temp1: boolean = false
  public persons: Person[];
  button: string = '';
  viewdata: any;
  currentUser: any;
  error_message: string;
  showError: boolean = false;
  clicked: boolean = false;
  customer: any;
  // newcustomerForm: any;
  addressService: any;

  dialogRef: any;
  companyId: any;
  userid: any;
  latitude: any;
  longitude: any;


  constructor(
    private toastr:ToastrService,
    private router: Router,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private dialog: MatDialog,
    private myreferralservice: ReferralService,
    private chRef: ChangeDetectorRef,
    private _addressService: AddressService,
    private route: ActivatedRoute) {
    this.getCountryList();
  }

  ngOnInit() {
    this.router.navigate(['/registration'], {
      queryParams: { companyId: 14954, userId: 16164 }
    });
    this.route.queryParams.subscribe(res => {
      this.companyId = res.companyId;
      this.userid = res.userId;
    })
    this.createForm();
    this.getPersonType();
    this.getCountryList();

  }
  createForm() {
    this.referralForm = this.fb.group({
      IsCompany: ['', Validators.required],
      CompanyName: ['', [Validators.maxLength(40), Validators.pattern("^[a-z A-Z]*$")]],
      Tax: [''],
      UserName: ['', [Validators.required, Validators.maxLength(40), Validators.pattern("^[a-z A-Z]*$")]],
      MobileNo: ['', [Validators.required, Validators.maxLength(18), Validators.minLength(10), Validators.pattern("^[0-9]*$")]],
      EmailId: ['', [Validators.required, Validators.email]],
      CountryId: [''],
      StateId: [''],
      CityId: [''],
      LocalityId: [''],
      Pincode: ['', [Validators.maxLength(18), Validators.minLength(5), Validators.pattern("^[0-9]*$")]],
      Address: [''],
      IFSCCode: ['', Validators.maxLength(20)],
      AccountHolderName: ['', [Validators.maxLength(40), Validators.pattern("^[a-z A-Z]*$")]],
      AccountNumber: ['', [Validators.maxLength(18), Validators.minLength(5), Validators.pattern("^[0-9]*$")]],
      BankName: ['', [Validators.maxLength(30), Validators.pattern("^[a-z A-Z]*$")]],
      AccountType: [''],
      BranchName: ['', [Validators.maxLength(30), Validators.pattern("^[a-z A-Z]*$")]],
      Percentage: ['10']
    });

    if (this._data.Action == 'Edit') {
      this.viewdata = this._data.Element;
      this.patchFormValue();
    }
  }
  patchFormValue() {
    throw new Error('Method not implemented.');
  }
  prepareReferral() {
    const controls = this.referralForm.controls;
    const _myReferral = new referralUser();
    const _bankDetail = new bankDetails();

    _myReferral.id = 0;
    _myReferral.companyId = 0;
    _myReferral.isCompany = controls['IsCompany'].value;
    _myReferral.UserName = controls['UserName'].value;
    _myReferral.companyName = controls['CompanyName'].value;
    // _myReferral.ContactPerson = controls['ContactPerson'].value;
    _myReferral.taxNumber = controls['Tax'].value;
    _myReferral.mobileNo = controls['MobileNo'].value;
    _myReferral.email = controls['EmailId'].value;
    _myReferral.address = controls['Address'].value;
    _myReferral.countryId = controls['CountryId'].value || 0;
    _myReferral.stateId = controls['StateId'].value || 0;
    _myReferral.cityId = controls['CityId'].value || 0;
    _myReferral.pincode = controls['Pincode'].value;
    _myReferral.percentage = controls['Percentage'].value;
    _myReferral.Longitude = this.longitude;
    _myReferral.Latitude = this.latitude;

    _bankDetail.id = 0;
    _bankDetail.referralUserId = 0;
    _bankDetail.ifscCode = controls['IFSCCode'].value;
    _bankDetail.accountHolderName = controls['AccountHolderName'].value;
    _bankDetail.accountNumber = controls['AccountNumber'].value;
    _bankDetail.bankName = controls['BankName'].value;
    _bankDetail.accountType = controls['AccountType'].value;
    _bankDetail.branchName = controls['BranchName'].value;
    return {
      referralUser: _myReferral,
      bankDetails: _bankDetail
    };
  }

  backpage() {
    this.router.navigate([""])
  }

  getCountryList() {
    this._addressService.getCountry().pipe(map((res: any) => {
      this.countryList = res;
      this.filterArrayCountry = res;
    })
    )
      .subscribe();
  }

  getStateList(CountryId) {
    this._addressService.getState(CountryId).pipe(map((res: any) => {
      if (res) {
        this.stateList = res;
        this.filterArrayState = res;
      }
    })
    )
      .subscribe();
  }

  getCityList(StateId) {
    this._addressService.getCity(StateId).pipe(map((res: any) => {
      if (res) {
        this.cityList = res;
        this.filterArrayCity = res;
      }
    })
    )
      .subscribe();
  }

  getLocalityList(CityId) {
    this.addressService
      .getLocality(CityId)
      .pipe(
        map((res: any) => {
          if (res) {
            this.localityList = res;
            if (this.customer.LocalityId > 0) {
              const toSelect = this.localityList.find(
                (c) => c.LocalityId == this.customer.LocalityId
              );
              this.referralForm
                .get("LocalityId")
                .setValue(toSelect.LocalityId);
            }
          }
        })
      )
      .subscribe();
  }

  filterValueCountry(event) {
    this.filterArrayCountry = this.countryList.filter(res => { return res.Name.toLowerCase().startsWith(event.toLowerCase()) })
  }

  filterValueState(event) {
    this.filterArrayState = this.stateList.filter(res => { return res.Name.toLowerCase().startsWith(event.toLowerCase()) })
  }

  filterValueCity(event) {
    this.filterArrayCity = this.cityList.filter(res => { return res.Name.toLowerCase().startsWith(event.toLowerCase()) })
  }

  openMap() {
    let address = this.referralForm.controls["Address"].value;
    const dialogRef = this.dialog.open(AddressDialogComponent, {
      width: "550px",
      data: {
        address: address,
        action: "",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;
      this.referralForm.controls["Address"].patchValue(result.res);
      this.longitude = result.longitude
      this.latitude = result.latitude
    });

  }


  onSubmit() {
    console.log("this.referralForm", this.referralForm.value)
    this.clicked = !this.clicked;
    this.hasFormErrors = false;
    const controls = this.referralForm.controls;
    /** check form */
    if (this.referralForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      this.hasFormErrors = true;
      return;
    }
    

    const addreferral = this.prepareReferral();

    this.createreferral(addreferral);

  }
  createreferral(addreferral: any) {
    this.myreferralservice.addreferral(addreferral, this.companyId, this.userid)
      .pipe(map(res => {
        if(res.status==200){
          this.router.navigate([""])
          // console.log(res);
        }
        // else{
        //   this.toastr.error('hello')
        // }
      }))
      .subscribe(res=> {},error=>{
        this.toastr.error(error.error.Message || error.error.title)
        console.log(error.error.Message|| error.error.title);
        
        // this.toastr.error(error.message)
      });
  }
  getPersonType(): void {
    this.persons = this.myreferralservice.getMockArray();
    this.chRef.detectChanges();
  }
}
